import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const SWB = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Southwestern Blot: This assay was designed to see the specificity of the aptamers towards the protein of interest, in this case CRP. The process consists in making a NATIVE PAGE gel electrophoresis with different samples of blood: serum, plasma, whole blood, serum without CRP and purified CRP; then the gel bands are migrated to a nitrocellulose plate and incubated with the aptamer. If the aptamer is bound to a different protein than CRP, then it has no good specificity. The aptamers had a fluorophore to detect its presence in the plate. This protocol was adapted from Siu et al. (2007) [3].</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/8.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 7. Diagram of South Western Blot protocol. Created with<br/>BioRender.com.</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default SWB;
